import React from 'react';
import ViewColumnsAdd, { ViewColumnsAddProps } from './add/ViewColumnsAdd';

type Props = ViewColumnsAddProps;

const ViewColumnsExcel: React.FC<Props> = props => {
  return (
    <ViewColumnsAdd
      isInModal={props.isInModal}
      columnsOptions={props.columnsOptions}
      selectedColumnsIds={props.selectedColumnsIds}
      viewMethod="excel"
      onChange={props.onChange}
    />
  );
};

export default ViewColumnsExcel;
